<template>
  <vbt-badge
    :color="color"
    small
  >
    {{ period }}
  </vbt-badge>
</template>

<script>
const COLOR_BY_PERIOD = Object.freeze({
  rush: 'info',
  today: 'info',
  tomorrow: 'success',
  yesterday: 'warning',
  'all periods': 'success',
});

export default {
  name: 'PbDashboardPeriodBadge',

  props: {
    period: {
      type: String,
      required: true,
    },
  },

  computed: {
    color() {
      return COLOR_BY_PERIOD[this.period.toLowerCase()] || 'success';
    },
  },
};
</script>
